module.exports = __webpack_public_path__ + "static/media/Bariol-Bold.0704d1c7.woff2";